<div class="w-full max-w-7xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>{{ 'label_incident_and_requests' | translate }}</h2>
    </div>
    <span class="separator-line block mb-[px]"></span>
    <br />
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-8 w-full mt-4 fade-in-left">
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_TECHNICAL_SUPPORT_REQUESTS)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/tolvuadstod-og-breytingabeidnir/senda-beidni">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                        <ng-container>
                            <img
                                class="w-full object-cover mt-1"
                                [src]="'assets/images/general/tolvu-og-breytingabeidnir/tolvu-og-breytingabeidnir.png'"
                            />
                        </ng-container>
                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_technical_support_requests' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_report_technical_support_request' | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <ng-container>
                                        <span>{{ 'label_register_request' | translate }}</span>
                                    </ng-container>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_ACCESS_REQUESTS)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/adgangsbeidnir">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden bg-card relative h-[100%]">
                        <ng-container>
                            <img class="w-full object-cover -mt-1" [src]="'assets/images/general/adgangur/adgangur.png'" />
                        </ng-container>

                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_access_request' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_access_request' | translatePlural }}
                                </div>
                            </ng-container>
                        </div>

                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <span>{{ 'label_open' | translate }}</span>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"> </mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_HOUSING_REQUESTS)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/husnaedi/senda-beidni">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                        <ng-container>
                            <img class="w-full object-cover mt-1" [src]="'assets/images/general/husnaedi/husnaedi.png'" />
                        </ng-container>
                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_housing_request' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_send_housing_request' | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <ng-container>
                                        <span>{{ 'label_register_request' | translate }}</span>
                                    </ng-container>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_INCIDENT_REPORT)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/atvikatilkynningar">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                        <ng-container>
                            <img class="w-full object-cover mt-1" [src]="'assets/images/general/atvik/atvik.png'" />
                        </ng-container>
                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_incident' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_report_incident' | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <ng-container>
                                        <span>{{ 'label_open' | translate }}</span>
                                    </ng-container>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
        <div class="sm:grid-flow-col xl:grid-flow-row">
            <a class="no-underline" routerLink="/atvik-og-beidnir/eftirlitsadgerdir/til-framkvaemdar">
                <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                    <ng-container>
                        <img class="w-full object-cover mt-1" [src]="'assets/images/general/eftirlitsadgerdir/eftirlitsadgerdir.png'" />
                    </ng-container>
                    <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                        <ng-container>
                            <div class="font-semibold line-clamp-3">
                                {{ 'label_monitoring_operations' | translate }}
                            </div>
                        </ng-container>
                        <ng-container>
                            <div>
                                {{ 'text_monitoring_operations' | translate }}
                            </div>
                        </ng-container>
                    </div>
                    <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                        <button mat-stroked-button>
                            <span class="inline-flex items-center">
                                <ng-container>
                                    <span>{{ 'label_view_monitoring_operations' | translate }}</span>
                                </ng-container>
                                <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                            </span>
                        </button>
                    </div>
                </div>
            </a>
        </div>
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_EMPLOYEE_SUPPORT_REQUESTS)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/styrkir/senda-beidni">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                        <ng-container>
                            <img class="w-full object-cover mt-1" [src]="'assets/images/general/styrkir/styrkir.png'" />
                        </ng-container>
                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_employee_support_request' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_employee_support_request' | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <ng-container>
                                        <span>{{ 'label_register_request' | translate }}</span>
                                    </ng-container>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
        @if (lsrauthService.inRole(userDetails, userRoles.SEND_EMPLOYEE_SUPPORT_REQUESTS)) {
            <div class="sm:grid-flow-col xl:grid-flow-row">
                <a class="no-underline" routerLink="/atvik-og-beidnir/hagsmunaskra">
                    <div class="flex flex-col shadow rounded-2xl overflow-hidden cursor-pointer bg-card relative h-[100%]">
                        <ng-container>
                            <img class="w-full object-cover mt-1" [src]="'assets/images/general/hagsmunaskra/hagsmunaskra.png'" />
                        </ng-container>
                        <div class="flex flex-auto flex-col p-6 pb-4 space-y-2">
                            <ng-container>
                                <div class="font-semibold line-clamp-3">
                                    {{ 'label_interest_register' | translate }}
                                </div>
                            </ng-container>
                            <ng-container>
                                <div>
                                    {{ 'text_interest_register' | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="px-6 py-4 text-right bg-gray-50 dark:bg-transparent">
                            <button mat-stroked-button>
                                <span class="inline-flex items-center">
                                    <ng-container>
                                        <span>{{ 'label_register' | translate }}</span>
                                    </ng-container>
                                    <mat-icon class="ml-1.5 icon-size-5" [svgIcon]="'heroicons_solid:arrow-sm-right'"></mat-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
        }
    </div>
</div>
